import * as styles from './CopyButton.module.css'

import React, { useState, useCallback } from 'react'
import classNames from 'classnames'

import * as icons from 'components/icons'
import { Button } from 'components/controls'

interface Props {
  children: string
  disabled?: boolean
  onClick(event: React.MouseEvent<HTMLButtonElement>): void
  up?: boolean
}

export const CopyButton: React.FC<Props> = (props) => {
  const { children, disabled, onClick, up = false } = props

  const [copied, setCopied] = useState(false)

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      onClick(event)

      setCopied(true)

      const timer = setTimeout(() => {
        setCopied(false)
      }, 1200)

      return () => {
        clearInterval(timer)
      }
    },
    [onClick],
  )

  return (
    <div className={styles.container}>
      <Button onClick={handleClick} disabled={disabled}>
        {children}
      </Button>

      <div
        className={classNames(styles.copiedNotification, {
          [styles.visible]: copied,
          [styles.up]: up,
        })}
      >
        <div>Copied to Clipboard</div>
        <div>
          <icons.Check color="#ffffff" />
        </div>
      </div>
    </div>
  )
}
